import { Component, OnInit, input, output } from '@angular/core';
import { BaseComponent } from '@shared-components/base-component';
import { AppHelper } from '@shared-helpers/appHelper';
import { ProductHelper } from '@shared-helpers/productHelper';
import { ProductModel } from '@shared-model/products/ProductModel';

@Component({
  selector: 'fourd-product-selector',
  templateUrl: './product-selector.component.html',
  providers: [...BaseComponent.componentProviders],
})
export class ProductSelectorComponent extends BaseComponent implements OnInit {
  readonly products = input<ProductModel[]>(undefined);
  readonly productActionStart = input<boolean>(false);
  selectedProduct = output<ProductModel>();

  productTypes: number[];

  constructor() { super("ProductSelectorComponent"); }

  ngOnInit() {
    this.productTypes = this.products()?.map(p => p.ProductTypeId)?.filter(AppHelper.arrayFilterDistinct);
  }

  filterProductsByTypeId(productList: ProductModel[], producTypeId: number): ProductModel[] {
    let result: ProductModel[] = [];

    result = productList.filter(pl => pl.ProductTypeId == producTypeId);
    return result;
  }

  selectProduct(product: ProductModel) {
    this.selectedProduct?.emit(product);
  }

  isProductOnlineChat(productTypeId: number): boolean {
    return ProductHelper.isProductTypeOnlineChat(productTypeId);
  }

  isProductBundleSession(productTypeId: number): boolean {
    return ProductHelper.isProductTypeBundleSession(productTypeId);
  }

  isProductPaygSession(productTypeId: number): boolean {
    return ProductHelper.isProductTypePaygSession(productTypeId);
  }

  isProductGeneralTopUp(productTypeId: number): boolean {
    return ProductHelper.isProductTypeGeneralTopUp(productTypeId);
  }

  isProductMinutesTopUp(productTypeId: number): boolean {
    return ProductHelper.isProductTypeMinutesTopUp(productTypeId);
  }

  isProductTypeIvr(productTypeId: number): boolean {
    return ProductHelper.isProductTypeIvr(productTypeId);
  }

  availableMinutesForProduct(product: ProductModel): number {
    return this.memberService?.availableMinutesForProduct(product);
  }

  paygProduct(): ProductModel {
    // Filter products to get PAYG, sort by price per minute (highest first) and take first
    return this.products()?.filter((p) => ProductHelper.isProductTypePayg(p?.ProductTypeId))?.sort((a, b) => b.PricePerMinute?.Amount - a.PricePerMinute?.Amount)?.find(() => true);
  }

}
